import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../constants';
import ColoredHeader from './layout/ColoredHeader';

const Content = styled.div`
  border: 1px solid ${COLORS.BACKGROUND_GRAY};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  padding: 10px;
  width: 100%;
`;

const PdfContent = styled.div`
  border: 1px solid ${COLORS.BACKGROUND_GRAY};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 100%;
`;

const PanelDiv = styled.div`
  margin: 10px
`;

const Header = styled(ColoredHeader)`
  margin-bottom: 0;
  background-color: rgb(201,0,95);
`;

const Panel = ({title, children, pdf}) => {
  return (
    <PanelDiv>
      <Header>{title}</Header>
      {pdf ? <PdfContent>{children}</PdfContent> : <Content>{children}</Content>}
    </PanelDiv>
  );
};

Panel.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
};

export default Panel;
